<template>
    <div>
        <v-row>
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors, valid }" name="Médico referenciado" rules="required|max:60">
                    <v-text-field label="Nombre" :counter="60" maxlength="60" v-model.trim="model.name" clearable required
                        @change="autoUserName" :error-messages="errors" dense :clear-icon="$cnst.CLEAR_ICON">
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                            {{ valid ? " mdi-check" : "" }}
                        </v-icon></v-text-field>
                </validation-provider>
            </v-col>
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors, valid }" name="Primer apellido" rules="required|max:60">
                    <v-text-field label="Primer apellido" :counter="60" maxlength="60" v-model.trim="model.firstLastname"
                        clearable required @change="autoUserName" :error-messages="errors" dense
                        :clear-icon="$cnst.CLEAR_ICON">
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                            {{ valid ? " mdi-check" : "" }}
                        </v-icon></v-text-field>
                </validation-provider>
            </v-col>
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors, valid }" name="Segundo apellido" rules="max:60">
                    <v-text-field label="Segundo apellido" :counter="60" maxlength="60" v-model.trim="model.secondLastname"
                        clearable @change="autoUserName" :error-messages="errors" dense :clear-icon="$cnst.CLEAR_ICON">
                        <v-icon slot="append" :color="valid && model.secondLastname ? 'success' : ''">
                            {{ valid && model.secondLastname ? " mdi-check" : "" }}
                        </v-icon></v-text-field>
                </validation-provider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors, valid }" name="Cédula profesional" rules="required|max:20">
                    <v-text-field label="Cédula profesional" :counter="20" maxlength="20"
                        v-model.trim="model.professionalLicense" clearable required :error-messages="errors" dense
                        :clear-icon="$cnst.CLEAR_ICON">
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                            {{ valid ? " mdi-check" : "" }}
                        </v-icon></v-text-field>
                </validation-provider>
            </v-col>
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors, valid }" name="Grado académico" rules="required|max:20">
                    <v-text-field label="Grado académico" :counter="20" maxlength="20" v-model.trim="model.academicTitle"
                        clearable required :error-messages="errors" dense :clear-icon="$cnst.CLEAR_ICON">
                        <v-icon slot="append" :color="valid ? 'success' : ''">
                            {{ valid ? " mdi-check" : "" }}
                        </v-icon></v-text-field>
                </validation-provider>
            </v-col>
            <v-col cols="12" md="2" sm="12" offset-md="1">
                <v-switch label="Acceso de usuario" dense inset v-model="model.hasUser" hide-details></v-switch>
            </v-col>
        </v-row>
        <v-row class="mb-3" v-if="model.hasUser">
            
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors }" name="Nombre de usuario" rules="required|max:50">
                    <v-text-field v-model.trim="model.user.username" :counter="50" :maxlength="50"
                    append-icon="mdi-restart"
                    @click:append="generareUsername"

                        label="Nombre de usuario*" required :error-messages="errors"></v-text-field>
                </validation-provider>
            </v-col>
            <v-col cols="12" md="4" sm="12">
                <validation-provider v-slot="{ errors }" name="Correo electrónico" rules="required|max:50|email">
                    <v-text-field v-model="model.contactInformation.email" :counter="50" :maxlength="50"
                        
                        label="Correo electrónico*" type="email" required :error-messages="errors"></v-text-field>
                </validation-provider>
                <p class="caption text--secondary">
                    Si desconoce el correo electrónico utiliza el
                    formato N/D
                </p>
            </v-col>
        </v-row>

    </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";

export default {
    name: "PaymentFormForm",
    components: {
        ValidationProvider,
    },
    props: {
        model: Object,
    },
    data() {
        return {
            isUpdate: false
        }
    },
    mounted() {
        this.model.user = { ... this.model.user };
        this.model.contactInformation = { ... this.model.contactInformation };
        this.isUpdate = this.$utilFront.nonEmpty(this.model.idDoctor);
    },
    methods: {
        autoUserName() {
            if (!this.isUpdate) {
                this.generareUsername();
            }
        },
        generareUsername() {
            let u1 = this.$utilFront.nonEmpty(this.model.name) ? this.model.name.substring(0, 2) : "";
            let u2 = this.$utilFront.nonEmpty(this.model.firstLastname) ? this.model.firstLastname.substring(0, 2) : "";
            let u3 = this.$utilFront.nonEmpty(this.model.secondLastname) ? this.model.secondLastname.substring(0, 2) : "";
            this.model.user.username = (u1 + u2 + u3).toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }
    }

};
</script>